import React from "react";
import { cn } from "../../lib/cn";

/** Standard page title + optional description + action buttons */
export function PageHeader({ title, description, actions, className }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 border-b border-brand/15 pb-6 sm:flex-row sm:items-end sm:justify-between",
        className
      )}
    >
      <div className="min-w-0">
        <h1 className="text-2xl font-extrabold tracking-tight text-brand-dark md:text-[1.65rem]">
          {title}
        </h1>
        {description ? (
          <p className="mt-1 max-w-2xl text-sm leading-relaxed text-slate-600">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}

/** Vertical spacing stack for page sections */
export function PageStack({ children, className }) {
  return (
    <div className={cn("space-y-6 pt-2", className)}>{children}</div>
  );
}

/** Low-chrome panel for dense content (no card border/shadow by default) */
export function DataSurface({ children, className }) {
  return (
    <div className={cn("min-w-0 overflow-visible bg-transparent", className)}>
      {children}
    </div>
  );
}
